angular.module('mtic')
.service('PlatformService', function ($cookies, $location, $log) {


  function generateQueryVarCache () {
    var splitQueryStr;
    var specialValues = {
      "f": false,
      "false": false,
      "null": null,
      "t": true,
      "true": true
    };
    splitQueryStr = window.location.search.substring(1).split('&')
    queryVarCache = splitQueryStr.reduce(
      function(cache, pairStr){
        var pair = pairStr.split('=').map(decodeURIComponent);
        var name = pair[0];
        var value = pair[1];
        var numericValue;
        if (value === undefined) {
          // value is undefined, but the name was still included in the query
          // string, so assume truthy. (This behaviour accommodates some legacy
          // URLs that contain 'web-embed-connect' and should not be relied
          // upon in the future)
          value = true;
        } else if (specialValues[value.toLowerCase()] !== undefined) {
          value = specialValues[value.toLowerCase()];
        } else if (value.split('.').length < 3 && !isNaN(numericValue = parseFloat(value))) {
          value = numericValue;
        }
        if (cache[name] !== undefined) {
          $log.warn('query string variable "' + name + '" declared more than once!');
        }
        cache[name] = value;
        return cache;
      },
      { __srcString: window.location.search }
    );
  }

  function getQueryVariable (variableName) {
    if (queryVarCache.__srcString !== window.location.search) {
      generateQueryVarCache();
    }
    return queryVarCache[variableName];
  }

  function isAndroid () {
    return !!navigator.userAgent.match(/Android/i);
  }

  function isAndroidEnabled () {
    if ($cookies.getObject('enableAndroid')) {
      return true;
    }

    if (getQueryVariable('enable-android')) {
      $cookies.putObject('enableAndroid', true);
      return true;
    }

    return false;
  }

  function isApp () {
    return (isAppAndroid() || isAppIos()) && !!window.parent.postMessage || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.cordova_iab);
  }

  function isAppAndroid () {
    return isAndroid() && (
      getQueryVariable('native-app') || /; wv\)/.test(navigator.userAgent)
    );
  }

  function isAppIos () {
    return  !isAppAndroid() && getQueryVariable('native-app');
  }

  function isIpad () {
    return /iPad/.test(navigator.userAgent);
  }

  function isIos () {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) || (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 0);
  }

  var isMobile = function () {
    return isAndroid() || isIos() || isApp() || (320 <= window.outerWidth && window.outerWidth <= 736); /** NOTE: window.outerWidth part is dev-only, remove for production **/
  };

  function supportsBeforeUnloadMsg () {
    return !isApp();
  }

  var supportsFlash = function () {
    return true//!isAndroid() && !isIos(); // this is false
  };

  function isPhonePortrait(){
    var el;
    return () => {
      el = el || document.querySelector('.phone-portrait'); // only accesses DOM once
      return window.getComputedStyle(el).display === 'block';
    };
  }

  var queryVarCache = {};
  var PlatformService = {
    getQueryVariable: getQueryVariable, // n.b. this one is a fn, not a fn call. This is not a mistake!
    isAndroid: isAndroid(),
    isAndroidEnabled: isAndroidEnabled(),
    isApp: isApp(),
    isIpad: isIpad(),
    isIos: isIos(),
    isMobile: isMobile(),
    isPhonePortrait: isPhonePortrait(), // unlike other fields, this is a function!
    supportsBeforeUnloadMsg: supportsBeforeUnloadMsg(),
    supportsFlash: supportsFlash()
  };

  return PlatformService;
});
// http://192.168.2.11:3000/index.html?enable-android=true&app-version=6.0.1&web-embed-connect=true&native-adal=true&duped=one&duped=two&native-app=true
